module.exports = __webpack_public_path__ + "img/IchMachDichMesser.cae8ba2e.jpg";